import { Drawer } from '@mui/material'
import { Box } from '@mui/system'
import { ReactNode } from 'react'
import { SIDEBAR_WIDTH, YARD_DRAWERS_WIDTH } from '../../helpers/yard-view.utils'

interface Props {
  open: boolean
  onClose: () => void
  fullHeight?: boolean
  children: ReactNode
}

/**
 * Shared shell for left-anchored persistent drawers in the Yard setup page.
 *
 * Encapsulates the common MUI `<Drawer>` scaffolding (anchor, variant, paper
 * width, sidebar offset, flexShrink) so individual drawers only declare
 * their open/close state and content.
 */
export const YardLeftDrawer = ({ open, onClose, fullHeight = false, children }: Props) => (
  <Drawer
    open={open}
    onClose={onClose}
    anchor='left'
    variant='persistent'
    sx={{
      flexShrink: 0,
      '& .MuiDrawer-paper': {
        width: YARD_DRAWERS_WIDTH,
        boxSizing: 'border-box',
        left: SIDEBAR_WIDTH,
      },
    }}
  >
    <Box width='100%' height={fullHeight ? '100%' : undefined}>
      {children}
    </Box>
  </Drawer>
)
